export function initLogoSlider($) {
  // Target the specific class you generated in PHP
  $(".logos-slider.has-slider").each(function () {
    var $this = $(this)[0]; // Splide needs the raw DOM element
  
    new Splide($this, {
      type: "loop",
      drag: "free",
      focus: "center",
      arrows: false,
      pagination: false,
      perPage: 7,
      gap: "40px",
      autoScroll: {
        speed: 1, // Continuous speed
        pauseOnHover: true, // Works instantly in Splide
        pauseOnFocus: false,
      },
      breakpoints: {
        1375: { perPage: 6 },
        1000: { perPage: 4 },
        768: { perPage: 3 },
        520: { perPage: 3 },
        400: { perPage: 2 },
      },
    }).mount(window.splide.Extensions); // Essential for AutoScroll
  });
}
